;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .controller('VulnEventsCtrl', VulnEventsCtrl)

  function VulnEventsCtrl(
    $scope,
    $controller,
    $routeParams,
    traceRenderService,
    ORG_VULN_EVENTS
  ) {
    'ngInject'

    function init() {
      var controller = $controller('BaseVulnEventsCtrl', { $scope: $scope })
      controller.$onInit()
      _emitTraceActiveEvent()

      traceRenderService
        .getEvents($scope.getTraceUuid(), $scope.model.tempOptions.legacy)
        .then($scope.afterGetEvents)
    }

    function _emitTraceActiveEvent() {
      var eventName = ORG_VULN_EVENTS.ORG_TRACE_ACTIVE
      if ($routeParams.serverId) {
        eventName = ORG_VULN_EVENTS.SERVER_TRACE_ACTIVE
      } else if ($routeParams.appId) {
        eventName = ORG_VULN_EVENTS.APP_TRACE_ACTIVE
      }
      $scope.$emit(eventName, { active: 'events' })
    }

    init()
  }
})()
